<div class="side-panel">
  <img src="/assets/images/network-graphic.png" alt="Document network" class="network-image" />
  <div class="text-content">
    <h2 class="heading">Transform Enterprise Documents into Actionable Intelligence</h2>
    <p class="subtext">Connect your SharePoint libraries and let AI surface insights, risks, and opportunities buried across thousands of documents—instantly.</p>
  </div>
</div>